
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <div class="layout__sidecol">
        <nav class="central-nav">
          <ul class="central-nav__list list-unstyled">
            <li>
              <a href="javascript:void(0);" routerLink="/broker-dashboard">
                <svg class="icon">
                  <use xlink:href="#policies"></use>
                </svg>
                <span>Dashboard</span>
              </a>
            </li>
            <li>
              <a href="javascript:;"  routerLinkActive="active" (click)="changeMode('Policies')">
                <svg class="icon">
                  <use xlink:href="#policies"></use>
                </svg>
                <span>Policies</span>
              </a>
            </li>
            <li>
              <a href="javascript:;"  routerLinkActive="active" (click)="changeMode('Quotes')">
                <svg class="icon">
                  <use xlink:href="#quotes"></use>
                </svg>
                <span>Quotes</span>
              </a>
            </li>
            <li class="is-active">
              <a href="javascript:;" class="is-active">
                <svg class="icon">
                  <use xlink:href="#quotes"></use>
                </svg>
                <span>Resources </span>
              </a>
            </li>

          </ul>
          <div class="central-nav__toggle" id="sidecol-toggle">
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
          </div>
        </nav>
      </div>

      <div class="layout__bodycol">
        <header class="central-header">
          <div class="central-header__title">
            <h3 class="font-normal">Resources</h3>
          </div>
          <div class="central-header__actions">
            <a href="#modal-resources-actions" data-toggle="modal" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-md-none">
              <svg class="icon">
                <use xlink:href="#more"></use>
              </svg>
            </a>

            <a href="javascript:void(0);" id="search-trigger-mobile" class="button-control d-md-none">
              <svg class="icon">
                <use xlink:href="#search-small"></use>
              </svg>
            </a>
            <a href="#modal-confirm-cover" data-toggle="modal" class="button button--md button--secondary d-none d-md-inline-block">Confirmation of Cover</a>
            @if (false) {
              <a href="javascript:void(0);" data-toggle="modal" class="button button--md button--secondary d-none d-md-inline-block">View History</a>
            }
          </div>
        </header>

        <div class="central-filter central-filter--tabnav">
          <div class="central-filter__tabnav">
            <nav class="tab-nav tab-nav--central">
              <div class="tab-nav__inner">
                <ul class="list-unstyled" id="policies-nav">
                  <li class="is-active"><a href="javascript:void(0);" data-category="all">All</a></li>
                </ul>
              </div>
            </nav>
          </div>

          <div class="central-filter__controls">
            <div class="central-filter__trigger is-active" id="search-trigger">
              <svg class="icon">
                <use xlink:href="#search-small"></use>
              </svg>
            </div>
            <div class="central-filter__search" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" placeholder="Search" id="search-input" autocomplete="off"
                  class="form-control form-control--sm"/>

                  <a href="javascript:void(0);" id="search-clear" class="form-control__clear">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>


          <div class="policy-tabs row row--sm row-eq-height" id="search-body">
            <div class="resource-item resource-item--confirmation is-active col-sm-6 col-md-4 col-xl-3" data-category="">
              <div class="resource-item__inner">
                <div class="resource-item__thumb">
                  <img src="assets/img/confirmation-letter.svg" class="img-fluid">
                </div>
                <div class="resource-item__content">
                  <p>Need <strong>confirmation of cover</strong> for one of your insured items?</p>
                  <a href="#modal-confirm-cover" data-toggle="modal" class="button button--md button--primary">Generate</a>
                </div>
              </div>
            </div>
            <div class="resource-item is-active col-sm-6 col-md-4 col-xl-3 0" data-category="0">
              <div class="resource-item__inner">

                <div class="resource-item__img">
                  <img src="assets/{{categoryId}}/img/resources/resources-transcript.svg" class="img-fluid">
                </div>
                <div class="resource-item__content">
                  <h5>Record of Advice</h5>
                  <p>...</p>
                </div>
                <div class="resource-item__tray">
                  <ul class="icon-list">
                    <li>
                      <a href="javascript:void(0);" (click)="printDoc('policy-transcript',false,true)" >
                        <svg class="icon icon--sm">
                          <use xlink:href="#download"></use>
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);" (click)="printDoc('policy-transcript',true,false)" >
                        <svg class="icon icon--sm">
                          <use xlink:href="#printer"></use>
                        </svg>
                      </a>
                    </li>
                  </ul>
                  <a routerLink="/policy-transcript" class="button button--sm button--primary">View</a>
                </div>

              </div>
            </div>

            <div class="resource-item is-active col-sm-6 col-md-4 col-xl-3 0" data-category="0">
              <div class="resource-item__inner">

                <div class="resource-item__img">
                  <img src="assets/{{categoryId}}/img/resources/resources-transcript.svg" class="img-fluid">
                </div>
                <div class="resource-item__content">
                  <h5>Policy Certificate Of Cover</h5>
                  <p>...</p>
                </div>
                <div class="resource-item__tray">
                  <ul class="icon-list">
                    <li>
                      <a href="javascript:void(0);" (click)="printDoc(RouterLinks.PolicyCertificateOfCover,false,true)" >
                        <svg class="icon icon--sm">
                          <use xlink:href="#download"></use>
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);" (click)="printDoc(RouterLinks.PolicyCertificateOfCover,true,false)">
                        <svg class="icon icon--sm">
                          <use xlink:href="#printer"></use>
                        </svg>
                      </a>
                    </li>
                  </ul>
                  <a [routerLink]="['/' + RouterLinks.PolicyCertificateOfCover]" class="button button--sm button--primary">View</a>
                </div>
              </div>
            </div>

            @for (document of documents; track document; let i = $index) {
              <div class="resource-item is-active col-sm-6 col-md-4 col-xl-3 0"
                [attr.data-index]="i">
                <div class="resource-item__inner">
                  <div class="resource-item__img">
                    <img src="assets/{{categoryId}}/img/resources/{{document.icon}}" class="img-fluid">
                  </div>
                  <div class="resource-item__content">
                    <h5>{{document.document_name}}</h5>
                    <p>...</p>
                  </div>
                  <div class="resource-item__tray">
                    <ul class="icon-list">
                      <li>
                        <a href="javascript:void(0);" (click)="openDocument(document,false, true)" >
                          <svg class="icon icon--sm">
                            <use xlink:href="#download"></use>
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" (click)="openDocument(document,true, false)">
                          <svg class="icon icon--sm">
                            <use xlink:href="#printer"></use>
                          </svg>
                        </a>
                      </li>
                    </ul>
                    <a href="javascript:void(0);" (click)="openDocument(document,false, false)"class="button button--sm button--primary">View</a>
                  </div>
                  <!-- <div class="resource-item__tray">
                  <a href="javascript:void(0);" (click)="openDocument(document,true)" class="button-control">
                    <svg class="icon">
                      <use xlink:href="#download"></use>
                    </svg>
                    <strong>Print</strong></a>
                    <a href="javascript:void(0);" (click)="openDocument(document,false)"
                    class="button button--sm button--primary">View</a>
                  </div> -->
                </div>
              </div>
            }
          </div>
        </div>

        <div class="table-noresults" id="search-noresults">
          <div class="table-noresults__content">
            <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
            <h3 class="font-normal">No results found</h3>
            <p>Try adjusting your search to find what you’re looking for.</p>
          </div>
        </div>
      </div>
    </div>
  </main>

  <app-disclaimer></app-disclaimer>


  <!-- tray menu modal (mobile only) -->
  <div class="modal fade modal--tray" id="modal-policy-menu" tabindex="-1" role="dialog"
    aria-labelledby="modal-traymenu-more" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content modal-traymenu">
        <div class="container">
          <div class="modal-traymenu__list list-unstyled">
            <a routerLink="/everything.policy-overview" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#policy-overview"></use>
              </svg>
              <div>Policy Overview</div>
            </a>
            <a routerLink="/everything.policy-insured-items" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#insured-items"></use>
              </svg>
              <div>Insured Items</div>
            </a>
            <a routerLink="/everything.policy-addons" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#policy-benefits"></use>
              </svg>
              <div>Benefits</div>
            </a>
            <a routerLink="/everything.policy-resources" data-dismiss="modal" class="modal-traymenu__list-item is-active">
              <svg class="icon">
                <use xlink:href="#policy-resources"></use>
              </svg>
              <div>Resources</div>
            </a>
            <a routerLink="/everything.policy-wording" data-dismiss="modal" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#policy-resources"></use>
              </svg>
              <div>Wording</div>
            </a>
            <a routerLink="/everything.policy-schedule" data-dismiss="modal" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#policy-resources"></use>
              </svg>
              <div>Schedule</div>
            </a>
          </div>

          <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
            <div>Close</div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- /modal -->

  <div class="modal fade modal--tray" id="modal-resources-actions" tabindex="-1" role="dialog" aria-labelledby="modal-resources-actions" aria-modal="true">
    <div class="modal-dialog">
      <div class="modal-content modal-traymenu">
        <div class="container">
          <div class="modal-traymenu__list list-unstyled">
            <a href="#modal-confirm-cover" data-toggle="modal" data-dismiss="modal" class="modal-traymenu__list-item">
              <svg class="icon">
                <use xlink:href="#policies"></use>
              </svg>
              <div>Confirmation of Cover</div>
            </a>
            @if (false) {
              <a href="#" class="modal-traymenu__list-item">
                <svg class="icon">
                  <use xlink:href="#history-small"></use>
                </svg>
                <div>View History</div>
              </a>
            }
          </div>

          <a href="#" data-dismiss="modal" class="modal-traymenu__close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
            <div>Close</div>
          </a>
        </div>
      </div>
    </div>
  </div>



  <div class="modal fade modal--alert" id="modal-confirm-cover" tabindex="-1" role="dialog" aria-labelledby="modal-confirm-cover" aria-modal="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert modal-alert--alt">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="/assets/{{policy.product_category_id}}/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <h3>Select item to generate a Confirmation of Cover Letter</h3>
            </div>
            <!-- <div class="form-group form-group--lg">
            <app-question-date-picker
              [question]="{ cent_aq_question_id: 2875, answer: '', email_version: 'Cover Start Date'}"
              [showLabel]="true"
              [numberMonths]="1"
              (questionAnswer)="saveCoverDate($event)">
            </app-question-date-picker>
          </div> -->

          <div class="custom-input__desktop-scroller">

            @for (item of items; track item; let i = $index) {
              <label class="custom-input custom-input--radio custom-input--vehicle" >
                <input type="radio" name="confirm-example-1" (click)="setSelectedItem(item)" value="{{item?.session_item_id}}">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">
                  <h5 class="font-16">{{item?.description_1?.split('|')[0]}}<span class="tag-pill tag-pill--personal">{{getClassName(item?.class_id)}}</span></h5>
                  <p class="helper-text">{{item?.description_2}}</p>
                </span>
              </label>
            }
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
          <a href="#modal-confirm-generated" id="generate-pdf-btn" [attr.disabled]="!selectedItem === false ? null: ''" class="button button--lg button--primary" data-toggle="modal" data-dismiss="modal">Generate</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="modal-confirm-generated" tabindex="-1" role="dialog" aria-labelledby="modal-confirm-generated" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/{{policy.product_category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte mb-30">
            <h3>Your Confirmation of Cover Letter has been generated</h3>
          </div>

          <ul class="action-list mt-20">
            <li>
              <a href="javascript:;" data-dismiss="modal" (click)="router.navigate(['/' + RouterLinks.PolicyConfirmationOfCover], {state: {item: selectedItem}})" >
                <svg class="action-list__icon icon">
                  <use xlink:href="#view-file"></use>
                </svg>
                <span>View</span>
                <svg class="action-list__arrow icon">
                  <use xlink:href="#chevron-right"></use>
                </svg>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" data-dismiss="modal" (click)="printDoc(RouterLinks.PolicyConfirmationOfCover,true,false)">
                <svg class="action-list__icon icon">
                  <use xlink:href="#printer"></use>
                </svg>
                <span>Print</span>
                <svg class="action-list__arrow icon">
                  <use xlink:href="#chevron-right"></use>
                </svg>
              </a>
            </li>
            <!-- <li>
            <a href="#share-email-modal" data-toggle="modal" data-dismiss="modal">
              <svg class="action-list__icon icon">
                <use xlink:href="#envelope"></use>
              </svg>
              <span>Share via Email</span>
              <svg class="action-list__arrow icon">
                <use xlink:href="#chevron-right"></use>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://wa.me/?text=Confirmation%20of%20Cover:%20https%3A%2F%2Fwww.everything.insure%2Flink-to-pdf" target="_blank">
              <img src="/assets/icn/whatsapp.svg" class="action-list__icon icon">
              <span>Send with WhatsApp</span>
              <svg class="action-list__arrow icon">
                <use xlink:href="#chevron-right"></use>
              </svg>
            </a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="modal-alert__button">
      <div class="container">
        <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Done</a>
      </div>
    </div>
  </div>
</div>
</div>
